import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Carousel.scss";
import { useMediaQuery } from "react-responsive";

// Desktop videos
import vid1 from "./Carousel Vids/Carousel-vid1.mp4";
import vid2 from "./Carousel Vids/Carousel-vid2.mp4";
import vid3 from "./Carousel Vids/Carousel-vid3.mp4";
import vid4 from "./Carousel Vids/Carousel-vid4.mp4";
import vid5 from "./Carousel Vids/Carousel-vid5.mp4";
import vid6 from "./Carousel Vids/Carousel-vid6.mp4";

// Mobile videos
import vidMo1 from "./Carousel Vids/Carousel (Mobile View)/1.mp4";
import vidMo2 from "./Carousel Vids/Carousel (Mobile View)/2.mp4";
import vidMo3 from "./Carousel Vids/Carousel (Mobile View)/3.mp4";
import vidMo4 from "./Carousel Vids/Carousel (Mobile View)/4.mp4";
import vidMo5 from "./Carousel Vids/Carousel (Mobile View)/5.mp4";
import vidMo6 from "./Carousel Vids/Carousel (Mobile View)/6.mp4";

function Carousel() {
  const isMobile = useMediaQuery({ maxWidth: 600 });

  /** 🔁 Select videos based on screen size */
  const slides = useMemo(() => {
    return isMobile
      ? [
          { type: "video", src: vidMo1 },
          { type: "video", src: vidMo2 },
          { type: "video", src: vidMo3 },
          { type: "video", src: vidMo4 },
          { type: "video", src: vidMo5 },
          { type: "video", src: vidMo6 },
        ]
      : [
          { type: "video", src: vid1 },
          { type: "video", src: vid2 },
          { type: "video", src: vid3 },
          { type: "video", src: vid4 },
          { type: "video", src: vid5 },
          { type: "video", src: vid6 },
        ];
  }, [isMobile]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalTime = 10000; // 10 seconds
  const slideInterval = useRef(null);

  const startAutoSlide = () => {
    stopAutoSlide();
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, intervalTime);
  };

  const stopAutoSlide = () => {
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
      slideInterval.current = null;
    }
  };

  /** ▶ Start autoplay & restart when mobile/desktop changes */
  useEffect(() => {
    setCurrentIndex(0);
    startAutoSlide();
    return stopAutoSlide;
  }, [slides]);

  const goToSlide = (index) => {
    stopAutoSlide();
    setCurrentIndex(index);
    startAutoSlide();
  };

  return (
    <div className="carousel">
      {/* Slide */}
      <div className="carousel-banner">
        <video
          key={slides[currentIndex].src}
          autoPlay
          muted
          loop={false}
          playsInline
          preload="auto"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={slides[currentIndex].src} type="video/mp4" />
        </video>
      </div>

      {/* Pagination Dots */}
      <div className="carousel-pagi-dot">
        <div className="dot-blank-div"></div>
        <div className="dot-container">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Carousel;
